// src/sections/ServiziSocial.jsx
import React from "react";

const Certificazioni = ({ contenuti }) => {
    const items = Array.isArray(contenuti)
        ? contenuti
        : Object.values(contenuti);

    // separo gli oggetti “testo” da quelli “immagine”
    const textItems = items.filter(item => !item.titolo_it.includes("[immagine]"));
    const imageItems = items.filter(item => item.titolo_it.includes("[immagine]"));

    return (
        <section id="certificazioni" className="mt-5 mb-5 py-5">
            <div className="container">
                <div className="row">
                    <div className="text-items mb-5">
                        {textItems.map(item => {
                            const text1 = item.titolo_it.split('|')[0];
                            const text2 = item.titolo_it.split('|')[1];

                        
                            return <> 
                            <div key={item.ID} className="text-center w-100 mb-4">
                                <h1 className="text-42 md-text-64 d-inline-block">{text1}</h1>
                                <h1 className="medium-green text-42 md-text-64 d-inline-block ps-2">{text2}</h1>
                                {item.descrizione_it && <p>{item.descrizione_it}</p>}
                            </div>
                            </>
                        })}
                    </div>

                    <div className="certificazioni">
                        {imageItems.map(item => (
                            <div key={item.ID} className="cert-item">
                                <a
                                    href={item.link_it || "#"}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={item.immagine_url}
                                        alt={item.titolo_it}
                                        className="w-100"
                                        style={{maxWidth:'300px'}}
                                    />
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Certificazioni;
